<template>
  <div class="auth-callback">
    <div class="loader-container">
      <div class="spinner"></div>
      <p>Procesando autenticación...</p>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { loginWithToken } from "@/services/api/authService";

export default {
  name: "AuthCallback",
  setup() {
    const store = useStore();
    const router = useRouter();
    const errorMessage = ref("");

    onMounted(async () => {
      // Extracción Robusta: Limpiamos el hash de caracteres extraños y manejamos variaciones
      const hash = window.location.hash.replace(/^#\/?/, "");
      const search = window.location.search.substring(1);
      
      const params = new URLSearchParams(hash || search);
      const accessToken = params.get("access_token");
      const idToken = params.get("id_token");
      
      // Guardamos un respaldo directo en localStorage antes de cualquier otra cosa
      if (idToken) {
        localStorage.setItem("keycloak_id_token", idToken);
      }
      const error = params.get("error");

      const targetWindow = window.opener || (window.parent !== window ? window.parent : null);
      const isPopup = !!window.opener;
      const isInIframe = window.parent !== window;

      if (targetWindow && (isPopup || isInIframe)) {
        // --- FLUJO POPUP O IFRAME ---
        if (accessToken) {
          // Enviar tokens a la ventana principal
          targetWindow.postMessage({ 
            type: "keycloak-token", 
            token: accessToken,
            idToken: idToken // CRÍTICO: Asegurar que se envía en el mensaje
          }, window.location.origin);
        } else if (error) {
          targetWindow.postMessage({ type: "keycloak-error", error }, window.location.origin);
        }
        
        if (isPopup) {
          // Cerrar la ventana emergente después de un breve delay
          setTimeout(() => {
            window.close();
          }, 500);
        }
      } else {
        // --- FLUJO DE REDIRECCIÓN ESTÁNDAR ---
        if (accessToken) {
          try {
            // Validar token con el backend de ACARA
            const response = await loginWithToken(accessToken);
            const userData = response.data || response;
            
            // Adjuntamos tokens para el Store
            const finalUserData = {
              ...(userData.data || userData),
              token: accessToken,
              idToken: idToken 
            };

            // Limpiamos flag de logout manual
            localStorage.removeItem("manual_logout");

            // Actualizar Store
            store.dispatch("login", finalUserData);
            
            // Redirigir al Home
            router.push({ name: "home" });
          } catch (err) {
            console.error("Error validando token en redirección:", err);
            errorMessage.value = "Error al sincronizar la sesión.";
            setTimeout(() => router.push({ name: "home" }), 3000);
          }
        } else {
          // Si no hay token ni comunicación, volver al home
          router.push({ name: "home" });
        }
      }
    });

    return {
      errorMessage
    };
  },
};
</script>

<style scoped>
.auth-callback {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-family: sans-serif;
}
.loader-container {
  text-align: center;
}
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #001f5b;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
